import React, { useRef, useEffect, useState, memo } from 'react';

import DiscountBtn from '../../DiscountBtn/DiscountBtn';
import styles from './DiscountPrice.module.less';

export default memo(({ soft, source }) => {
  const priceNode = useRef(null);
  const [showPrice, setShowPrice] = useState(true);
  const [clickTag, setClickTag] = useState(false);
  const [hoverPrice, setHoverPrice] = useState(false);

  useEffect(() => {
    if (priceNode?.current.clientWidth > 130) {
      setShowPrice(false);
    } else {
      setShowPrice(true);
    }
  }, [priceNode]);

  const showCurrentPrice = () => {
    if (soft?.currentPrice === null) {
      return false;
    } else {
      if (soft?.currentPrice === soft?.originalPrice) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleZk = () => {
    let c = soft?.currentPrice;
    let o = soft?.originalPrice;
    let price = null;
    if (c && o) {
      price = Math.round((c / o) * 10 * 10) / 10;
      return price > 0.1 ? `${price}` : '0.1';
    }
  };

  return (
    <div
      className={styles.soft_buy}
      onClick={e => {
        setClickTag(true);
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseEnter={() => {
        setHoverPrice(true);
      }}
      onMouseLeave={() => {
        setHoverPrice(false);
      }}
    >
      <div className="price" ref={priceNode}>
        {showCurrentPrice() && (
          <div className="zk">
            <span>{handleZk()}</span>
            <span>折</span>
          </div>
        )}

        <div className="n_price">
          <span>¥</span>
          {soft?.currentPrice !== null ? (
            <span>{soft?.currentPrice}</span>
          ) : (
            <span>{soft?.originalPrice}</span>
          )}
        </div>
        {showCurrentPrice() && showPrice && <div className="o_price">¥{soft?.originalPrice}</div>}
      </div>
      <div
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <DiscountBtn
          soft={soft}
          info={{ className: styles.btn, tagClass: styles.btn_tag }}
          logInfo={{ source: source }}
          clickCallbackTag={clickTag}
          reductionTag={() => setClickTag(false)}
          hoverTag={hoverPrice}
        />
      </div>
    </div>
  );
});
